<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<InventoryNavi />
			<div class="widget-location" style="display:flex; justify-content: space-between; align-items: center;">
				<h3>상품등록</h3>
				<div class="get-order" v-if="!isMobile">
					<div class="top">
						<ul>
							<li>1688<img src="../../assets/icon/shipping-auto-img1.png" alt="1688" loading="lazy"></li>
							<li>타오바오<img src="../../assets/icon/shipping-auto-img2.png" alt="타오바오" loading="lazy"></li>
						</ul>
						<a @click="onOrderlayer" class="event-common-click-dialog">구매목록<br>가져오기</a>
					</div>
				</div>
			</div>
			
			<div class="item-info">
				<el-form :model="ruleForm"  ref="ruleForm" label-width="0" > <!-- :rules="rules" -->
					<!-- 动态表单项列表 -->
					<div 
						v-for="(item, index) in ruleForm.items" 
						:key="item.id" 
					>
					
						<div class="form-item" >
							<el-row>
								<el-col :xs="24" :sm="8" class="item" style="flex-direction: row; align-items: center; justify-content: flex-start; gap: 20px;">
									<el-button type="primary" @click="onUpload(index)" size="small">
										이미지 등록
									</el-button>
									<a target="_blank" :href="item.imageUrl" v-if="item.imageUrl" style="display: flex;">
										<el-image
											style="width:50px;height:50px;border-radius: 4px;"
											:src="item.imageUrl"
											fit="cover"></el-image>
									</a>
								</el-col>
								<el-col :xs="24" :sm="8" class="item">
									<div class="from-title">품목분류 <span class="required-addon">(*)</span></div>
									<el-form-item  :prop="`items.${index}.category_name`"
									:rules="[
										{ required: true, message: '품목분류 필수', trigger: 'change' },
									]">
										<el-popover
											placement="bottom"
											width="700"
											trigger="click"
											v-model="item.showPopover"
											@show="onCategoryDialog(index)"
											popper-class="category-popper"
											style="flex: 1;"
										>
											<div class="category-dropdown-content">
												<div class="scroller-container">
													<div class="v-table-header">
														<div class="v-col-l1">1차 분류</div>
														<div class="v-col-l2">2차 분류 (HS Code)</div>
														<div class="v-col-l3">3차 분류 (상세)</div>
													</div>
													
													<RecycleScroller
														class="category-v-scroller"
														:items="item.showPopover ? filteredCategories : []"
														:item-size="65"
														key-field="uniqueId"
														v-slot="{ item: catItem }"
													>
														<div class="v-category-row" @click="handleSelectCategory(catItem)" style="cursor: pointer;">
															<div class="v-col-l1">
																<div class="ko" v-html="highlightCategoryText(catItem.l1)"></div>
															</div>
															<div class="v-col-l2">
																<div class="ko">
																	<span v-html="highlightCategoryText(catItem.l2)"></span>
																	<span class="code">({{' '}}<span v-html="highlightCategoryText(catItem.l2_code)"></span>{{' '}})</span>
																</div>
																<div class="cn" v-if="catItem.l2_cn" v-html="highlightCategoryText(catItem.l2_cn)"></div>
															</div>
															<div class="v-col-l3">
																<div class="ko" v-html="highlightCategoryText(catItem.l3)"></div>
																<div class="code" v-if="catItem.l3_code !== '-'" v-html="highlightCategoryText(catItem.l3_code)"></div>
															</div>
														</div>
													</RecycleScroller>
												</div>
											</div>
											<el-input 
												slot="reference" 
												v-model="item.category_name" 
												placeholder="분류를 입력하거나 선택하세요" 
												@input="onSearchInput(index)"
												class="input-frame"
											></el-input>
										</el-popover>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
											<div>
										   	원하시는 품목분류가 없으신가요?<br>추가희망 하시는 품목분류를 고객센터로<br>알려주시면 즉시 추가하여드립니다
											</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">상품명(영문) <span class="required-addon">(*)</span></div>
									<el-form-item  :prop="`items.${index}.goods_name`"
									:rules="[
										{ required: true, message: '상품명 필수', trigger: 'blur' },
									]">
										<el-input v-model="item.goods_name" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										   <div>검색( HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다</div>
												<i class="el-icon-question icon-question" slot="reference"></i>
										</el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">적하품명(영문) </div><!--卸载货物(英文) 描述概况-->
									<el-form-item  :prop="`items.${index}.descript`">
										<el-input v-model="item.descript" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">상품코드 </div><!--商品代码-->
									<el-form-item  :prop="`items.${index}.code`">
										<el-input v-model="item.code" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										    <div>국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">단가 <span class="required-addon">(*)</span></div><!--单价-->
									<el-form-item  :prop="`items.${index}.price`"
									:rules="[
										{ required: true, message: '단가 필수', trigger: 'blur' },
									]">
										<el-input v-model="item.price" class="input-frame" @input="item.price = item.price.match(/^\d*(\.?\d{0,2})/g)[0] || ''"></el-input>
										CNY
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">브랜드/셀러 </div><!-- 销售方-->
									<el-form-item  :prop="`items.${index}.seller`" >
										<el-input v-model="item.seller" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">바코드 </div><!-- 条形码 -->
									<el-form-item  :prop="`items.${index}.barcode`">
										<el-input v-model="item.barcode" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">색상(중국어) </div><!-- 颜色（中文） -->
									<el-form-item  :prop="`items.${index}.color`">
										<el-input v-model="item.color" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">사이즈(중국어) </div><!-- 尺寸（中文） -->
									<el-form-item  :prop="`items.${index}.size`">
										<el-input v-model="item.size" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">HS CODE </div>
									<el-form-item  :prop="`items.${index}.hs_code`">
										<el-input v-model="item.hs_code" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">상품 URL <span class="required-addon">(*)</span></div>
									<el-form-item  :prop="`items.${index}.url`"
									:rules="[
											{ required: true, message: '상품 URL 필수', trigger: 'blur' },
											{ type: 'url', message: '올바른 URL 형식이 아닙니다', trigger: 'blur' }
									]">
										<el-input v-model="item.url" type="url" class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						
							<el-form-item style="padding: 10px;">
								<!-- 删除按钮 -->
							  <el-button 
								type="danger" 
								icon="el-icon-delete" 
								@click="removeItem(index)"
								:disabled="ruleForm.items.length <= 1"
							  >
								삭제
							  </el-button>
							  <el-button
								type="primary" 
								icon="el-icon-plus" 
								@click="addItem"
							  >
								상품추가
							  </el-button>
							</el-form-item>
				
							<!-- <el-form-item style="text-align: center;padding: 30px 0;">
								<el-button type="primary" @click="submitForm('ruleForm')" round>등록하기</el-button>					
							</el-form-item> -->
						</div>
					</div>
					<!--上传图像-->
					<el-dialog
					  title="이미지 등록" :width="isMobile?'90%':'30%'"
					  :visible.sync="uploadVisible" center>
					    <el-radio-group v-model="upload" size="mini" @change="changeUpload">
					      <el-radio :label="1" style="margin-bottom: 10px;">이미지 직접 업로드</el-radio>
					      <el-radio :label="2" style="margin-bottom: 10px;">이미지 URL 등록</el-radio>
					    </el-radio-group>
						<div v-if="upload==1">							
							<!-- https://jsonplaceholder.typicode.com/posts/ -->
					  		<el-upload
					  		  class="avatar-uploader"
					  		  :action="update_url+'/common/upload'"
					  		  :show-file-list="false"
					  		  :on-success="handleAvatarSuccess"
					  		  :before-upload="beforeAvatarUpload">
							<!-- 	<img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
								 <el-image v-if="imageUrl"
								      class="avatar"
								      :src="imageUrl"
								      fit="cover"></el-image>
								<!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
							   <el-button size="small" plain type="primary">업로드 클릭</el-button>
					  		</el-upload>			  
						</div>
						<div v-else>
					  		<el-input v-model="imageUrl" placeholder="URL은 http포함해서 입력해 주세요."></el-input>			  
						</div>
					
					  <span slot="footer" class="dialog-footer">
					    <el-button type="primary" @click="submitUpload">등록하기</el-button>
					  </span>
					</el-dialog>
					
					<!-- 商品分类弹框 已改为下拉 Popover -->
					
					<el-dialog
					  :visible.sync="centerDialogVisible" :close-on-press-escape="false" :close-on-click-modal="false"
					  :width="isMobile?'90%':'50%'" 
					  @close="onCloseImport"
					  center>
					  <div>
							<div class="section-header">
								<h1><span>타오바오/1688</span> 주문서 자동등록</h1>
								<p>중국 쇼핑몰의 주문 상세내역을 전체 복사(Ctrl+C)하여 하단의 공란에<br>
								붙여넣기(Ctrl+V)하신 후 가져오기 버튼을 눌러주세요</p>
								<a href="/deliveryAuto" target="_blank"><img src="../../assets/icon/info-icon.png" alt="자동등록 이용방법">자동등록 이용방법</a>
							</div>
							<el-select v-model="site_value" @change="changeSite" placeholder="">
							    <el-option
							      v-for="item in options"
							      :key="item.value"
							      :label="item.label"
							      :value="item.value">
							    </el-option>
							</el-select>
							<!-- 核心：可编辑的 div -->
							<div  @paste="handlePaste" ref="handlePaste"  contenteditable="true" style="margin-top: 10px; height: 200px;  overflow-y: auto;  border: 1px solid #ddd; border-radius: 10px; padding: 10px;">
							</div>
								
					  </div>
					  <span slot="footer" class="dialog-footer" >
					    <el-button round @click="onCloseImport">닫기</el-button>
					    <el-button style=" background:#ff5700;color:#FFF;" round @click="onImportOrder">가져오기</el-button>
					  </span>
					</el-dialog>
				</el-form>
			</div>		
			<div style="text-align: center;margin: 0 0 30px;">
				<el-button  type="primary" @click="submitForm('ruleForm')" round>등록하기</el-button>		
			</div>
	
			
		</div>

		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request';
	import Constants from '@/constants'
	import categoryData from '@/assets/fenlei_final_with_10_names_no_cat4.min.json'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				update_url:"",
				category_index:'',
				CategoryVisible: false,
				category_list:[],
				search: '',
				flattenedCategories: [],
				categorySearch: '',
				ruleForm: {
					items: [],
					
				},
				uploadVisible: false,
				
				upload_index:'',
				upload: 1,
				//input:'',
				imageUrl:'',
				centerDialogVisible: false,
				options: [{
				  value: '',
				  label: '쇼핑몰 선택'
				}, {
				  value: '1688',
				  label: '1688'
				}, {
				  value: 'taobao',
				  label: '타오바오 (淘宝)'
				}],
				site_value: '',
				pasted_html:'',
				// rules: {
				//   category_name: [
				// 	{ required: true, message: '请输入품목분류', trigger: 'blur' },
				//   ],
				//   goods_name: [
				// 	{ required: true, message: '请输入상품명(영문)', trigger: 'blur' }
				//   ],
				//   price: [
				// 	{ required: true, message: '请输入단가', trigger: 'blur' }
				//   ],
				//   url: [
				//   	{ required: true, message: '请输入상품 URL', trigger: 'blur' }
				//   ],		
				// },
	
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
			filteredCategories() {
				if (!this.categorySearch) {
					return this.flattenedCategories
				}
				const query = this.categorySearch.toLowerCase()
				return this.flattenedCategories.filter(item => {
					return (
						(item.l1 && item.l1.toLowerCase().includes(query)) ||
						(item.l2 && item.l2.toLowerCase().includes(query)) ||
						(item.l2_code && item.l2_code.toLowerCase().includes(query)) ||
						(item.l2_cn && item.l2_cn.toLowerCase().includes(query)) ||
						(item.l2_en && item.l2_en.toLowerCase().includes(query)) ||
						(item.l3 && item.l3.toLowerCase().includes(query)) ||
						(item.l3_code && item.l3_code.toLowerCase().includes(query))
					)
				})
			},
		},	
		mounted() {
			console.log(Constants.BASE_URL) 
			this.update_url = Constants.BASE_URL
		},
		created(){
			// 初始化时添加一个空表单项
			this.addItem()
		},
		methods: {
			submitUpload(){
				console.log(this.imageUrl,"选择那种上传方式1")
				console.log(this.upload,"选择那种上传方式")
				if(this.upload == 2){
					//添加图片链接时
					this.uploadVisible = false
					//this.ruleForm.items[this.upload_index].imageUrl = this.imageUrl
					
					request.post('/Images/uploadByUrl',
						{url:this.imageUrl}
					).then(response => {
					console.log(response,"提交")			  
						if(response.code ==1){
							alert('Success！');
							console.log(response,'提交成功！');
							this.imageUrl = ""
							this.ruleForm.items[this.upload_index].imageUrl = response.data.fullurl
							console.log(response.data.url)
							this.ruleForm.items[this.upload_index].goods_image = response.data.url
							//console.log(this.ruleForm.items[this.upload_index].goods_image,"提交图片2")
						}else{
							alert(response.msg)
							return
						}		
					});
											  
					
					
				
				}else if(this.upload == 1){
					this.uploadVisible = false
					this.ruleForm.items[this.upload_index].imageUrl = this.imageUrl
					this.imageUrl = ""
					console.log(this.ruleForm.items[this.upload_index].goods_image,"提交图片1")
				}
				
			},
			onUpload(index){
				this.upload_index = index
				this.uploadVisible = true
			},
			//文件上传成功时的钩子
			handleAvatarSuccess(res, file) {
				console.log(file,"上传成功")
				//this.imageUrl = URL.createObjectURL(file.raw);
				this.imageUrl = file.response.data.fullurl;
				this.ruleForm.items[this.upload_index].goods_image = file.response.data.url;
				
			},
			//上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
			beforeAvatarUpload(file) {
				console.log(file)
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				if (!isJPG && !isPNG) {
				  this.$message.error('이미지 형식은 JPG 또는 PNG만 가능합니다.');
				  return false
				}
				if (!isLt2M) {
				  this.$message.error('이미지 크기는 2MB를 초과할 수 없습니다.');
				   return false
				}
				//return isJPG && isLt2M;
			},
			changeUpload(value){
				console.log(value,"切换")
				//this.upload = value	
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// 表单验证通过，准备提交数据
						const submitData = {
							items: [...this.ruleForm.items]
						}
						console.log(submitData,"结果")
						
						
							request.post('/member/Inventory/registerGoods',
								submitData
							).then(response => {
							console.log(response,"注册")			  
								if(response.code ==1){
									alert('상품 등록 성공！');
									console.log(response,'提交成功！');
									if (this.$route.query.type === 'coupang' || this.$route.query.activeMenu) {
										this.$router.replace({ query: { ...this.$route.query, type: 'coupang', activeMenu: 'coupang_inventory_item' } }).catch(() => {});
									} else {
										this.$router.replace('/inventoryItem').catch(() => {});
									}
								}else{
									alert(response.msg)
									console.log(response,'提交失败！');
									return
								}
								
							});
						  
						  
						console.log(this.ruleForm,"商品提交")
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
			},
		
			generateId() {
			  return Date.now() + '_' + Math.random().toString(36).substr(2, 9)
			},
			
			/**
			 * 添加新的表单项
			 */
			addItem() {
			  this.ruleForm.items.push({
				id: this.generateId(), // 唯一标识，用于key
				category_id:'',
				category_name:'',
				goods_name: '',//唯一判断?
				descript:'',
				code:'',//唯一判断?
				price:'',
				seller:'',
				barcode:'',
				color:'',
				size:'',
				hs_code:'',
				url:'',
				
				goods_image:'',
				imageUrl: '',
				showPopover: false,
			  })
			},
			/**
			 * 删除指定索引的表单项
			 * @param {Number} index - 要删除的表单项索引
			 */
			removeItem(index) {
				this.ruleForm.items.splice(index, 1)
			},
			onSearch(){
				console.log(this.search)
				this.getCategoryList()
			},
			getCategoryList(){
				request.post('/member/Agency/getCategoryList',{
					search:this.search
				})
				.then(res => {
					console.log(res,"212")
					if(res.code ==1){
						this.category_list = res.data
					}
						
				});
				
			},
			onCategoryDialog(index){
				this.category_index = index
				this.CategoryVisible = true
				if (this.flattenedCategories.length === 0) {
					this.processCategories()
				}
			},
			processCategories() {
				const result = []
				let counter = 0
				categoryData.categories.forEach((cat) => {
					cat.items.forEach((item) => {
						if (item.hscode_10_details && item.hscode_10_details.length > 0) {
							item.hscode_10_details.forEach((h10) => {
								result.push({
									uniqueId: counter++,
									item_id: item.id,
									l1: cat.category_name,
									l2: item.name_ko,
									l2_code: item.hs_code,
									l2_cn: item.name_cn,
									l2_en: item.name_en,
									l3: h10.hscode_10_name,
									l3_code: h10.hscode_10
								})
							})
						} else {
							result.push({
								uniqueId: counter++,
								item_id: item.id,
								l1: cat.category_name,
								l2: item.name_ko,
								l2_code: item.hs_code,
								l2_cn: item.name_cn,
								l2_en: item.name_en,
								l3: '-',
								l3_code: '-'
							})
						}
					})
				})
				this.flattenedCategories = Object.freeze(result)
			},
			highlightCategoryText(text) {
				if (!this.categorySearch || text === undefined || text === null || text === '-') return text
				const str = String(text)
				const query = this.categorySearch.trim().toLowerCase()
				if (!query) return str
				const regex = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
				return str.replace(regex, match => `<span class="hl-text-category">${match}</span>`)
			},
			handleSelectCategory(row) {
				console.log("选择分类:", row)
				if (this.category_index !== '') {
					const item = this.ruleForm.items[this.category_index];
					item.category_name = row.l2;
					item.goods_name = row.l2_en;
					item.hs_code = (row.l3_code && row.l3_code !== '-') ? row.l3_code : row.l2_code;
					item.category_id = row.item_id;
					item.showPopover = false;
				}
			},
			onSearchInput(index) {
				this.categorySearch = this.ruleForm.items[index].category_name
				this.ruleForm.items[index].showPopover = true
				this.category_index = index
			},
			onCategoryName(id,name){
				// 暂时由 handleSelectCategory 处理
			},
			handlePaste(e) {
				const clipboardData = e.clipboardData || window.clipboardData;
				const pastedText = clipboardData.getData("text/html");
				if (!pastedText) return;
				const parser = new DOMParser()
				const doc = parser.parseFromString(pastedText, 'text/html')
				this.pasted_html = doc;
			},
			onCloseImport(){
				this.pasted_html = '';
				if (this.$refs.handlePaste) this.$refs.handlePaste.innerHTML = '';
				this.centerDialogVisible = false
			},
			onOrderlayer(){
				this.centerDialogVisible = true	
			},

			changeSite(value){
				this.site_value = value
			},
			onImportOrder(){
				if(!this.site_value){
					alert("쇼핑몰을 선택하세요.");
					return;
				}
				if (!this.pasted_html) {
				  if (this.$refs.handlePaste) {
				  	const parser = new DOMParser()
					const doc = parser.parseFromString(this.$refs.handlePaste.innerHTML, 'text/html')
					this.pasted_html = doc;
				  }
				}
				let doc = this.pasted_html;
				if (!doc) {
					alert("제출할 데이터가 없습니다!");
					return;
				}
				
				let parsedItems = [];
				if(this.site_value == "1688"){
					let itemNodes = doc.querySelectorAll(".order-list-content order-item .order-item-entry-container .order-item-entry");
					if (itemNodes.length === 0) {
						itemNodes = doc.querySelectorAll(".order-item-entry");
					}
					for (let i = 0; i < itemNodes.length; i++) {
						const node = itemNodes[i];
						const goodsNameEl = node.querySelector('.product-name');
						const priceEl = node.querySelector('.actual-unit-price');
						const imgEl = node.querySelector('img');
						let imgSrc = imgEl ? imgEl.getAttribute('src') : '';
						if (imgSrc) {
							imgSrc = imgSrc.replace('_160x160.jpg_.webp', '');
							if (imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;
						}
						
						// 1688 规格抓取：精准定位并过滤干扰（如：7天无理由退货等）
						const noiseRegex = /理由|退换|退货|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
						const specEls = Array.from(node.querySelectorAll('.sku-info-item, .product-prop, .spec-info, .spec-item'))
							.map(el => el.textContent.trim())
							.filter(txt => txt && !noiseRegex.test(txt));
						
						let color = "";
						let size = "";
						
						if (specEls.length > 0) {
							// 0. 特殊处理：分号分隔 (尺寸;颜色)
							const semiPair = specEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
							if (semiPair) {
								const parts = semiPair.split(/[;；]/).map(p => p.trim());
								if (parts.length >= 2) {
									size = parts[0];
									color = parts[1];
								}
							}
							
							// 1. 尝试按标签匹配
							if (!color || !size) {
								const colorIdx = specEls.findIndex(txt => /颜色[:：]/.test(txt));
								const sizeIdx = specEls.findIndex(txt => /尺码[:：]/.test(txt));
								
								if (colorIdx !== -1) color = specEls[colorIdx].replace(/颜色[:：]\s*/, '').trim();
								if (sizeIdx !== -1) size = specEls[sizeIdx].replace(/尺码[:：]\s*/, '').trim();
							}
							
							// 2. 如果还是没有，使用启发式位置（没有逗号默认填尺寸）
							if (!color && !size && specEls[0]) {
								size = specEls[0];
							} else {
								if (!color && specEls[0]) color = specEls[0];
								if (!size && specEls[1]) size = specEls[1];
							}
							
							if (color === size && color !== "") {
								// 如果只有一个项，且被同时赋给了color和size(由于逻辑逻辑)，根据“没有逗号填尺寸”，清空color
								if (!specEls[1]) color = ""; 
								else size = ""; // 这种情况不应该发生，除非specEls[0]和[1]内容相同
							}
						}
						
						// 兜底方案
						if (!color && !size) {
							const text = node.innerText || '';
							const cMatch = text.match(/颜色[:：]\s*([^;；\n\t]+)/);
							const sMatch = text.match(/尺码[:：]\s*([^;；\n\t]+)/);
							color = cMatch ? cMatch[1].trim() : '';
							size = sMatch ? sMatch[1].trim() : '';
						}

						parsedItems.push({
							goods_name: goodsNameEl ? goodsNameEl.textContent.trim() : '',
							price: priceEl ? priceEl.textContent.trim().replace('¥', '').trim() : '',
							url: goodsNameEl ? goodsNameEl.getAttribute('href').replace('new.goods.productname', '') : '',
							goods_image: imgSrc,
							color: color,
							size: size
						});
					}
				} else if(this.site_value == "taobao"){
					// 先尝试完整路径，部分复制时外层容器可能不存在，回退到直接匹配
					let itemNodes = doc.querySelectorAll(".trade-content-container .trade-container .trade-bought-list-order-info");
					if (itemNodes.length === 0) {
						itemNodes = doc.querySelectorAll(".trade-bought-list-order-info");
					}
					for (let i = 0; i < itemNodes.length; i++) {
						const node = itemNodes[i];
						const goodsNameEl = node.querySelector('div>div>div>div>a>span:first-of-type');
						const integerEl = node.querySelector('div>div:not(.trade-price-container-underline) .trade-price-integer');
						const decimalEl = node.querySelector('div>div:not(.trade-price-container-underline) .trade-price-decimal');
						const urlEl = node.querySelector('div>div:nth-of-type(2)>div:first-of-type>div>a');

						const goods_name = goodsNameEl ? goodsNameEl.textContent.trim() : '';
						const price = (integerEl ? integerEl.textContent : '') + '.' + (decimalEl ? decimalEl.textContent : '');
						let url = urlEl && urlEl.getAttribute('href') ? urlEl.getAttribute('href') : '';
						if (url && url.startsWith('//')) url = 'https:' + url;
						
						// 提取淘宝商品图片
						let tbImg = '';
						const bgEl = node.querySelector('span[data-spm="suborder_itempic"] a');
						if (bgEl) {
							const style = bgEl.getAttribute('style');
							if (style) {
								const match = style.match(/background-image:\s*url\(["']?(.*?)["']?\)/);
								if (match && match[1]) {
									tbImg = match[1];
								}
							}
						}
						if (!tbImg) {
							const tbImgEl = node.querySelector('img');
							if (tbImgEl) tbImg = tbImgEl.getAttribute('src') || '';
						}
						if (tbImg && tbImg.startsWith('//')) tbImg = 'https:' + tbImg;
						
						// 淘宝规格抓取：精准定位并过滤干扰（如：7天无理由退货、极速退款等）
						const noiseRegex = /理由|退换|退货|极速|退款|保|赠品|快照|假一赔|服务|分期|保险|赠送/;
						const skuEls = Array.from(node.querySelectorAll('.sku-info-item, .info, .sku-info, [class*="sku--"], .trade-clamp-wrap, .trade-clamp-ellipsis'))
							.map(el => el.textContent.trim())
							.filter(txt => txt && !noiseRegex.test(txt));
						
						let color = "";
						let size = "";
						
						if (skuEls.length > 0) {
							// 0. 特殊处理：如果存在分号分隔且没有标签，按“颜色;尺寸”提取
							const semiPair = skuEls.find(txt => (txt.includes(';') || txt.includes('；')) && !/[:：]/.test(txt));
							if (semiPair) {
								const parts = semiPair.split(/[;；]/).map(p => p.trim());
								if (parts.length >= 2) {
									color = parts[0];
									size = parts[1];
								}
							}

							// 1. 尝试按标签匹配（如果上面没抓到或者想覆盖）
							if (!color || !size) {
								const colorIdx = skuEls.findIndex(txt => /(?:颜色分类|颜色)[:：]/.test(txt));
								const sizeIdx = skuEls.findIndex(txt => /(?:尺码|尺寸)[:：]/.test(txt));
								
								if (colorIdx !== -1) color = skuEls[colorIdx].replace(/(?:颜色分类|颜色)[:：]\s*/, '').trim();
								if (sizeIdx !== -1) size = skuEls[sizeIdx].replace(/(?:尺码|尺寸)[:：]\s*/, '').trim();
							}
							
							// 2. 如果还是没有，使用启发式位置（没有逗号默认填尺寸）
							if (!color && !size && skuEls[0]) {
								size = skuEls[0];
							} else {
								if (!color && skuEls[0]) color = skuEls[0];
								if (!size && skuEls[1]) size = skuEls[1];
							}
							
							if (color === size && color !== "") {
								if (!skuEls[1]) color = "";
								else size = "";
							}
						}
						
						// 兜底方案：从全文中正则匹配
						if (!color && !size) {
							const itemText = node.innerText || "";
							const cMatch = itemText.match(/(?:颜色分类|颜色)[:：]\s*([^;；\n\t]+)/);
							const sMatch = itemText.match(/(?:尺码|尺寸)[:：]\s*([^;；\n\t]+)/);
							color = cMatch ? cMatch[1].trim() : '';
							size = sMatch ? sMatch[1].trim() : '';
						}

						parsedItems.push({ 
							goods_name, 
							price, 
							url, 
							goods_image: tbImg,
							color: color,
							size: size
						});
					}
				}

				if (parsedItems.length > 0) {
					this.ruleForm.items = this.ruleForm.items.filter(item => item.goods_name || item.price || item.url || item.category_name);
					
					const newItems = parsedItems.map(pi => ({
						id: this.generateId(),
						category_id:'', category_name:'',
						goods_name: pi.goods_name,
						descript:'', code:'',
						price: pi.price,
						seller:'', barcode:'', color: pi.color || '', size: pi.size || '', hs_code:'',
						url: pi.url,
						goods_image: pi.goods_image || '', imageUrl: pi.goods_image || '',
						showPopover: false
					}));
					this.ruleForm.items.push(...newItems);
					this.pasted_html = '';
					if (this.$refs.handlePaste) this.$refs.handlePaste.innerHTML = '';
					this.centerDialogVisible = false;
					this.$nextTick(() => {
						this.$message({ type: 'success', message: '주문 데이터를 성공적으로 가져왔습니다!', duration: 2000 });
					});
				} else {
					this.$message.warning("주문 데이터를 찾을 수 없습니다. 복사한 내용을 확인해주세요.");
				}
			},
			
		}
	
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.required-addon{
		font-family: inherit;
		color: var(--main-color);
		font-weight: inherit;
		vertical-align: inherit;
	}
	/* Compact Card Container */
	.item-info .form-item {
		background: #ffffff !important;
		border: 1px solid #eff3f9 !important;
		border-radius: 12px !important;
		padding: 16px 14px !important;
		margin-bottom: 20px !important;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.01) !important;
	}

	/* Flex wrapper to kill the floated columns wrapping bug */
	.form-item > .el-row {
		display: flex !important;
		flex-wrap: wrap !important;
		margin-left: -8px !important;
		margin-right: -8px !important;
	}

	/* Tight Grid Items */
	.item-info .item {
		display: flex !important;
		flex-direction: column !important;
		align-items: flex-start !important;
		padding: 6px 8px !important;
		box-sizing: border-box !important;
		margin-bottom: 10px !important;
		float: none !important;
	}

	/* Tiny, Crisp置顶标签 */
	.from-title {
		font-size: 12px !important;
		font-weight: 700 !important;
		color: #4a5568 !important;
		margin-bottom: 4px !important;
		width: 100% !important;
		display: flex !important;
		align-items: center !important;
		justify-content: flex-start !important;
		height: 18px !important;
	}

	/* Compact input component wrapper */
	.input-frame {
		width: 100% !important;
		margin: 0 !important;
	}
	::v-deep .el-input__inner {
		border-radius: 6px !important;
		border-color: #cbd5e1 !important;
		height: 32px !important;
		line-height: 32px !important;
		font-size: 12px !important;
		padding: 0 10px !important;
		transition: all 0.2s ease !important;
	}
	::v-deep .el-input__inner:focus {
		border-color: #ff5700 !important;
	}
	
	/* Tiny layout helper */
	.el-form-item {
		margin-bottom: 0 !important;
		width: 100% !important;
	}
	::v-deep .el-form-item__content {
		display: flex !important;
		align-items: center !important;
		width: 100% !important;
		gap: 6px !important;
		color: #718096 !important;
		font-weight: 600 !important;
		font-size: 12px !important;
	}

	/* Tight validation layout to prevent grid height expansion */
	::v-deep .el-form-item__error {
		font-size: 11px !important;
		padding-top: 2px !important;
		position: relative !important;
		margin-top: 2px !important;
		display: block !important;
		width: 100% !important;
	}

	/* Help tooltip icons */
	.icon-question {
		color: #94a3b8 !important;
		font-size: 14px !important;
		cursor: pointer !important;
		margin-left: 2px !important;
		transition: color 0.2s ease !important;
	}
	.icon-question:hover {
		color: #ff5700 !important;
	}

	/* Image upload button tight design matching 32px inputs height */
	.item-info .item .el-button--primary:not(.form-item .el-form-item .el-button) {
		height: 32px !important;
		line-height: 32px !important;
		border-radius: 6px !important;
		font-weight: 700 !important;
		font-size: 12px !important;
		background-color: #3b82f6 !important;
		border-color: #3b82f6 !important;
		box-shadow: 0 3px 6px rgba(59, 130, 246, 0.1) !important;
		transition: all 0.2s ease !important;
		margin-top: 22px !important;
		width: 100% !important;
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
		padding: 0 !important;
	}
	.item-info .item .el-button--primary:not(.form-item .el-form-item .el-button):hover {
		background-color: #2563eb !important;
		border-color: #2563eb !important;
		box-shadow: 0 4px 10px rgba(59, 130, 246, 0.2) !important;
	}
	.item-info .item a {
		margin-top: 6px !important;
		display: inline-block !important;
	}
	.item-info .item a .el-image {
		margin-left: 0 !important;
		border-radius: 6px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05) !important;
	}

	/* 分类弹框 */
	.agency-category-customs{
		display: flex;
	}
	.agency-category-customs .type-general{
		background-color: #0055d4;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.agency-category-customs .type-list{
		background-color: #c33;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.help-block{
	    background-color: #d5e6fa;
	    color: #274780;
	    display: flex;
	    min-height: 40px;
		padding:5px 0;
	    border-radius: 12px;
	    align-items: center;
	    padding-left: 19px;
	    margin: 17px 0 20px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
	/* 	background: #F5F8FD; */
		padding: 15px;
		margin: 25px 0 5px;
		border-radius: 20px;
	}
	.height-fixed-box{
		/* background: #F5F8FD; */
		height: 400px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box ol {
	    margin: 0;
	    padding: 0;
	}
	.height-fixed-box .depth1 {
	    border: 1px solid #e5e5e5;
	    border-radius: 13px;
	    margin-bottom: 20px;
	}
	.height-fixed-box li {
	    margin: 0 0 30px 0;
	    padding: 0;
	    list-style: none;
	}
	.height-fixed-box li li {
	    display: inline-flex;
	    align-items: center;
	    margin: 0;
	    padding: 3px 5px;
	    width: 30%;
	    font-size: 13px;
	}
	.height-fixed-box li strong.namecolor-blue {
	    background-color: #0055d4;
	    border-top-left-radius: 8px;
	    border-top-right-radius: 8px;
	    padding: 9px 25px 6px;
	    font-size: 15px;
	    margin-bottom: 0;
	}
	.height-fixed-box li strong {
	    display: block;
	    background: #666;
	    color: #fff;
	    font-weight: 500;
	}
	.height-fixed-box .name{
		cursor: pointer;
	}
	.height-fixed-box .name:hover{
		text-decoration: underline; /* 悬停时添加下划线 */
	}
	/* 上传 */
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	}
	.avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	}
	.avatar {
	    width: 178px;
	    height: 178px;
	    display: block;
	}

	/* 分类虚拟下拉样式 */
	.category-popper {
		max-width: 100vw;
		padding: 0 !important;
	}
	.category-dropdown-content {
		padding: 15px;
		background: #fff;
	}
	.scroller-container {
		border: 1px solid #eee;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		height: 400px;
	}
	.v-table-header {
		display: flex;
		background-color: #f0f7ff;
		height: 40px;
		align-items: center;
		padding: 0 15px;
		font-weight: bold;
		color: #0055d4;
		font-size: 13px;
		border-bottom: 1px solid #d0e3f7;
	}
	.category-v-scroller {
		flex: 1;
	}
	.v-category-row {
		display: flex;
		align-items: center;
		padding: 0 15px;
		height: 65px;
		border-bottom: 1px solid #f5f5f5;
		box-sizing: border-box;
	}
	.v-category-row:hover {
		background-color: #fafafa;
	}
	.v-col-l1 { width: 120px; flex-shrink: 0; color: #0055d4; font-weight: bold; font-size: 13px; }
	.v-col-l2 { width: 220px; flex-shrink: 0; padding: 0 10px; display: flex; flex-direction: column; justify-content: center; }
	.v-col-l3 { flex: 1; min-width: 0; padding-left: 10px; display: flex; flex-direction: column; justify-content: center; }
	
	.v-category-row .ko { font-size: 13px; color: #333; margin-bottom: 2px; }
	.v-category-row .cn { font-size: 11px; color: #e67e22; font-weight: 500; }
	.v-category-row .code { color: #999; font-family: monospace; font-size: 11px; }

	::v-deep .hl-text-category {
		background-color: #fffb8f;
		color: #f5222d;
		font-weight: bold;
		padding: 0 2px;
		border-radius: 2px;
	}
	
	.flex{
		display: flex;
	}
	.get-order {
		background: #ffffff !important;
		border: 1px solid #eff3f9 !important;
		padding: 8px 12px !important;
		border-radius: 16px !important;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03) !important;
	}
	.get-order .top {
		display: flex !important;
		align-items: center !important;
		gap: 12px !important;
	}
	.get-order ul {
		list-style-type: none !important;
		padding: 0 !important;
		display: flex !important;
		flex-direction: row !important;
		gap: 8px !important;
		margin: 0 !important;
	}
	.get-order li {
		background: #f8fafc !important;
		border: 1px solid #e2e8f0 !important;
		border-radius: 8px !important;
		color: #4a5568 !important;
		font-weight: 700 !important;
		display: flex !important;
		align-items: center !important;
		justify-content: space-between !important;
		padding: 0 12px !important;
		width: auto !important;
		min-width: 120px !important;
		height: 38px !important;
		box-shadow: none !important;
		white-space: nowrap !important;
	}
	.get-order li img {
		height: 16px !important;
		width: auto !important;
		margin-left: 6px !important;
	}
	.event-common-click-dialog {
		display: inline-flex !important;
		justify-content: center !important;
		align-items: center !important;
		height: 38px !important;
		width: 140px !important;
		border-radius: 8px !important;
		font-size: 13px !important;
		font-weight: 700 !important;
		color: #ffffff !important;
		background: #ff5700 !important;
		box-shadow: 0 4px 10px rgba(255, 87, 0, 0.2) !important;
		text-decoration: none !important;
		cursor: pointer !important;
		transition: all 0.2s ease !important;
		border: none !important;
		text-align: center !important;
		padding: 0 10px !important;
		line-height: normal !important;
	}
	.event-common-click-dialog:hover {
		background: #e04e00 !important;
		box-shadow: 0 6px 14px rgba(255, 87, 0, 0.3) !important;
	}

	/* Card Button controls for each product entry */
	.form-item .el-form-item {
		display: flex !important;
		justify-content: flex-end !important;
		gap: 12px !important;
		margin-top: 20px !important;
		border-top: 1px dashed #eff3f9 !important;
		padding-top: 15px !important;
		width: 100% !important;
	}
	.form-item .el-form-item .el-form-item__content {
		display: flex !important;
		justify-content: flex-end !important;
		gap: 12px !important;
		width: 100% !important;
	}
	.form-item .el-form-item .el-button {
		height: 38px !important;
		border-radius: 8px !important;
		font-weight: 700 !important;
		font-size: 13px !important;
		transition: all 0.2s ease !important;
		margin: 0 !important;
		padding: 0 18px !important;
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.form-item .el-form-item .el-button--danger {
		background-color: #fee2e2 !important;
		border-color: #fca5a5 !important;
		color: #ef4444 !important;
	}
	.form-item .el-form-item .el-button--danger:hover {
		background-color: #fecaca !important;
		border-color: #ef4444 !important;
	}
	.form-item .el-form-item .el-button--primary {
		background-color: #3b82f6 !important;
		border-color: #3b82f6 !important;
		color: #ffffff !important;
		box-shadow: 0 4px 10px rgba(59, 130, 246, 0.1) !important;
	}
	.form-item .el-form-item .el-button--primary:hover {
		background-color: #2563eb !important;
		border-color: #2563eb !important;
		box-shadow: 0 6px 14px rgba(59, 130, 246, 0.2) !important;
	}

	/* Register Button redesign at the very bottom */
	.item-info + div {
		text-align: center !important;
		margin: 30px 0 !important;
	}
	.item-info + div .el-button--primary {
		width: 200px !important;
		height: 46px !important;
		border-radius: 23px !important;
		font-weight: 700 !important;
		font-size: 15px !important;
		background: #ff5700 !important;
		border-color: #ff5700 !important;
		box-shadow: 0 6px 20px rgba(255, 87, 0, 0.2) !important;
		transition: all 0.3s ease !important;
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.item-info + div .el-button--primary:hover {
		background: #e04e00 !important;
		box-shadow: 0 10px 30px rgba(255, 87, 0, 0.35) !important;
		transform: translateY(-2px) !important;
	}

	.section-header {
	    position: relative;
	    border-bottom: 1px solid #e0e0e0;
	    margin-bottom: 20px;
	}
	.section-header h1 {
	    font-size: 22px;
	    font-weight: bold;
	    letter-spacing: -0.01em;
	    margin-top: 0px;
		margin-bottom: 40px;
	    text-align: left;
	}
	.section-header h1 span {
	    color: #ff5700;
	}
	.section-header p {
	    font-size: 14px;
	    line-height: 20px;
	    letter-spacing: -0.01em;
	    margin-bottom: 27px;
	}
	.section-header a {
	    display: inline-flex;
	    align-items: center;
		font-size: 14px;
	    font-weight: 700;
	    color: #f75551;
	    gap: 7px;
	}
	.color-blue {
	    color: #0055d4 !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			/* width: 800px; */
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		.item-info .item{
			padding:10px 20px;
			display: flex;
			/* justify-content:space-between; */
		}
		.from-title{
			font-size: 13px;
			width: 90px;
		}
		
	}
</style>